export { GetOLCertificateURLForAnonStudentQuery } from './get-ol-certificate-url-for-anon-student';
export { GetOLCertificatesURLForDictation2024 } from './get-ol-certificates-url-for-dictation-2024';
